export default _(18).times((index) => ({
    age: index,
    name: !index ? 'до 1 года' : `${index} ${index.wordEnding('год;года;лет')}`,
}));